import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import ModalContext from '../../contexts/modal-context';

import {
  useGetUserQuery,
  useDeleteLocalDomainMutation,
} from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

import styles from '../../styles/deleteModal.module.scss';

import sprite from '../../icons/sprite.svg';

const DeleteLocalDomain = () => {
  const dispatch = useDispatch();
  const localDomain = useSelector(
    (state) => state.localDomains.localDomainToUpdate
  );
  const { isShowDeleteLocalDomainModal, setDeleteLocalDomainModalState } =
    useContext(ModalContext);

  const {
    data: { user_id },
  } = useGetUserQuery();

  const [deleteLocalDomain] = useDeleteLocalDomainMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: `${localDomain.name} удален`,
  };

  const onToggleModal = () => {
    return setDeleteLocalDomainModalState(false);
  };

  const deleteLocalDomainHandler = async () => {
    try {
      await deleteLocalDomain({ user_id, id: localDomain.id });
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      dispatch(
        notificationSuccess({
          isNotification: true,
          type: 'error',
          message: 'Произошла ошибка',
        })
      );
    }

    return setDeleteLocalDomainModalState(false);
  };

  return (
    <Modal
      isOpen={isShowDeleteLocalDomainModal}
      title="Удалить локальный домен?"
      onClose={onToggleModal}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingTop: 12,
            paddingBottom: 24,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены что хотите удалить локальный домен
          <br />
          &nbsp;"{localDomain.name}"?
        </Typography>
        <div className="button-grid">
          <Button variant="secondary" onClick={onToggleModal} size="small">
            Отмена
          </Button>
          <Button
            variant="primary"
            onClick={deleteLocalDomainHandler}
            size="small"
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteLocalDomain;
